import { Person } from 'schema-dts';
import { useAtomValue } from 'jotai';
import { ExperienceUtil } from 'shared/models';
import { Region } from '@lemon8/web-app-shared/i18n';
import { $CurrentAvailableExperienceDataOrNull } from '../../shared/atoms';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { loadable } from 'jotai/utils';

export const useArticleAuthorJsonld = (): Person | null => {
  const loadableExperience = useAtomValue(loadable($CurrentAvailableExperienceDataOrNull));
  const { region } = useAtomValue($Locale);

  if (loadableExperience.state !== 'hasData' || !loadableExperience.data) {
    return null;
  }

  const { articleInfoList = [] } = loadableExperience.data;

  if (!articleInfoList.length) {
    return null;
  }
  const { author, articleRegion = region } = articleInfoList[0];

  return ExperienceUtil.JsonLD.getPersonJsonLD({ user: author, userRegion: articleRegion as Region });
};
